import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CheckCircle } from '@phosphor-icons/react';

export default function FinishSummary() {
  const location = useLocation();
  const navigate = useNavigate();
  const { totalSets, totalVolume, routineName } = location.state || {};

  return (
    <div className="mobile-container min-h-screen bg-bone flex items-center justify-center px-6">
      <div className="w-full max-w-sm text-center">
        <CheckCircle size={80} weight="fill" className="text-userRed mx-auto mb-6" />
        <h1 className="text-4xl font-black font-heading uppercase tracking-tight text-graphite mb-2">
          Session Complete
        </h1>
        <p className="text-base text-graphite/80 mb-8">{routineName}</p>

        <div className="border border-hairline p-6 mb-8">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-graphite/60 mb-2">
                Total Sets
              </p>
              <p className="text-5xl font-black font-heading tabular-nums text-graphite">
                {totalSets || 0}
              </p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-graphite/60 mb-2">
                Volume
              </p>
              <p className="text-5xl font-black font-heading tabular-nums text-graphite">
                {Math.round(totalVolume || 0)}
                <span className="text-lg font-normal">kg</span>
              </p>
            </div>
          </div>
        </div>

        <button
          onClick={() => navigate('/')}
          className="w-full h-16 bg-graphite text-bone font-black text-base uppercase tracking-wider"
          data-testid="done-button"
        >
          Done
        </button>
      </div>
    </div>
  );
}
